import { useState } from 'react';

import { useLocalStorage } from '@mint-lib/hooks';
import { useTranslation } from '@mint-lib/i18n';
import { Information } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';

import { AutoImportInfoDialog } from '../organisms/AutoImportInfoDialog/index.js';

export const AutoImportInfoButton = () => {
  const { t } = useTranslation('@myn/import-hub');

  const [isAlertClosed] = useLocalStorage<boolean>(
    '@myn/import-hub.isAutoImportAlertClosed',
    { initialValue: false },
  );

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);

  if (isAlertClosed) {
    return (
      <>
        <Button
          onClick={openDialog}
          variant="text"
          data-dd-action-name="How does the auto-import work?"
        >
          <Information />
          {t('How does the auto-import work?')}
        </Button>
        {isDialogOpen && <AutoImportInfoDialog onClose={closeDialog} />}
      </>
    );
  }
};
